import { render, staticRenderFns } from "./role_add.vue?vue&type=template&id=cbf70240&scoped=true&"
import script from "./role_add.vue?vue&type=script&lang=js&"
export * from "./role_add.vue?vue&type=script&lang=js&"
import style0 from "./role_add.vue?vue&type=style&index=0&id=cbf70240&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf70240",
  null
  
)

export default component.exports